import React, { Suspense } from 'react';

const PageLayoutV1 = React.lazy(() => import('./components-v1/page-layout'));

export function LoginCE(): React.JSX.Element {
	return (
		<Suspense fallback={<div></div>}>
			<PageLayoutV1 isAdvanced={false} />
		</Suspense>
	);
}
